var broadcasts_ctas = {
  initialize: function () {
    $(".broadcasts-cta, .broadcasts-cta-list").each(function (
      i,
      broadcasts_cta_div
    ) {
      $(broadcasts_cta_div)
        .find(".object-remove, .broadcast-remove")
        .unbind("click")
        .on("click", function (i, delete_icon) {
          if (
            confirm(
              "Are you sure you want to remove this campaign from this experiment? Doing so will clear any stats this campaign has associated with this experiment"
            )
          ) {
            $.ajax({
              type: "DELETE",
              async: true,
              url:
                window.location.origin +
                "/websites/" +
                $(broadcasts_cta_div).attr("data-website-id") +
                "/broadcasts/" +
                $(broadcasts_cta_div).attr("data-broadcast-id") +
                "/broadcasts_cta/" +
                $(broadcasts_cta_div).attr("data-id"),
            });
          }
        });

      broadcasts_ctas.bind_traffic_form(broadcasts_cta_div);
    });

    broadcasts_ctas.update_control_hint();
  },

  rotate_mode: function () {
    return $("#broadcasts-ctas-table").attr("data-delivery-mode") === "rotate";
  },

  bind_traffic_form: function (broadcasts_cta_div) {
    var percentage_form = $(broadcasts_cta_div).find(
      'form[data-type="broadcasts-cta-traffic"]'
    );
    if (!percentage_form.length) return;

    percentage_form
      .find(".percentage")
      .unbind("keyup change")
      .on("keyup change", function () {
        var input = $(this);
        var value = parseInt(input.val(), 10);
        if (value > 100) {
          input.val("100");
        } else if (value < 0) {
          input.val("0");
        }

        if (broadcasts_ctas.rotate_mode()) {
          value = parseInt(input.val(), 10);
          if (isNaN(value)) value = 0;

          var other_total = 0;
          $('form[data-type="broadcasts-cta-traffic"] .percentage')
            .not(input)
            .each(function () {
              var other = parseInt($(this).val(), 10);
              other_total += isNaN(other) ? 100 : other;
            });

          if (value + other_total > 100) {
            input.addClass("error");
            percentage_form.find("button").hide();
            return;
          }
        }

        input.removeClass("error");
        percentage_form.find("button").show();
      });

    percentage_form.unbind("submit").on("submit", function (e) {
      e.preventDefault();
      var input = percentage_form.find(".percentage");
      var value = parseInt(input.val(), 10);
      if (isNaN(value)) value = 0;

      $.ajax({
        type: "PUT",
        url: percentage_form.attr("action"),
        data: {
          broadcasts_cta: {
            percentage: value,
          },
        },
        success: function () {
          input.val(value);
          input.removeClass("error");
          percentage_form.find("button").hide();
          broadcasts_ctas.update_control_hint();
        },
        error: function () {
          input.addClass("error");
        },
      });
    });
  },

  update_control_hint: function () {
    var hint = $(".broadcasts-cta-control-hint");
    if (!hint.length) return;

    var total = 0;
    $('form[data-type="broadcasts-cta-traffic"] .percentage').each(function () {
      var value = parseInt($(this).val(), 10);
      total += isNaN(value) ? 100 : value;
    });

    var remaining = Math.max(100 - total, 0);
    hint.find(".broadcasts-cta-control-remaining").text(remaining);
    if (broadcasts_ctas.rotate_mode() && remaining > 0) {
      hint.show();
    } else {
      hint.hide();
    }
  },
};

export default broadcasts_ctas;
